import React, { useState, useContext, useEffect } from 'react'
import constants from '../../util/constants'
import StoreContext from '../../providers/storesContext'
import ReleaseMethodItem from './ReleaseMethodItem'
import AssistedReleaseModal from './AssistedReleaseModal'
import SelfReleaseModal from './SelfReleaseModal'

const ReleaseMethods = ({
  isSelfRelease = false,
  isAssistedRelease = false,
  selectReleaseMethod,
}) => {
  const [visibleAssistedReleaseModal, setVisibleAssistedReleaseModal] = useState(false)
  const [visibleSelfReleaseModal, setVisibleSelfReleaseModal] = useState(false)
  const { caseDetailStore } = useContext(StoreContext)
  const [selfReleaseDescription, setSelfReleaseDescription] = useState('');

  useEffect(() => {
    const fetchDescription = async () => {
      const description = await caseDetailStore.getSelfReleaseDescription()
      setSelfReleaseDescription(description)
    }
    fetchDescription()
  }, [])

  const showAssistedReleaseModal = (e) => {
    e.stopPropagation()
    e.preventDefault()

    setVisibleAssistedReleaseModal(true)
  }
  const hideAssistedReleaseModal = () => setVisibleAssistedReleaseModal(false)
  const showSelfReleaseModal = (e) => {
    e.stopPropagation()
    e.preventDefault()

    setVisibleSelfReleaseModal(true)
  }
  const hideSelfReleaseModal = () => setVisibleSelfReleaseModal(false)

  const handleSelectSelfRelease = () => selectReleaseMethod(constants.releaseMethodCodes.Manual)
  const handleSelectAssistedRelease = () =>
    selectReleaseMethod(constants.releaseMethodCodes.Assisted)

  return (
    <div className="mt-6">
      <div className="font-bold pb-3">Release Method</div>
      {caseDetailStore.selfReleaseAvailable && (
        <ReleaseMethodItem
          description={selfReleaseDescription}
          price={caseDetailStore.getReleasePrice(constants.releaseMethodCodes.Manual)}
          handleSelect={handleSelectSelfRelease}
          handleOpenModal={showSelfReleaseModal}
          isSelected={isSelfRelease}
          title="Self release"
        />
      )}
      {caseDetailStore.assistedReleaseAvailable && (
        <ReleaseMethodItem
          price={caseDetailStore.getReleasePrice(constants.releaseMethodCodes.Assisted)}
          handleSelect={handleSelectAssistedRelease}
          handleOpenModal={showAssistedReleaseModal}
          description="Our staff will be dispatched after payment is processed to release your vehicle. You will receive an SMS message notifying you of when the device has been removed from your vehicle."
          isSelected={isAssistedRelease}
          title="Assisted release"
        />
      )}

      {caseDetailStore.selfReleaseAvailable && (
        <SelfReleaseModal handleClose={hideSelfReleaseModal} open={visibleSelfReleaseModal} />
      )}

      {caseDetailStore.assistedReleaseAvailable && (
        <AssistedReleaseModal
          handleClose={hideAssistedReleaseModal}
          open={visibleAssistedReleaseModal}
        />
      )}
    </div>
  )
}

export default ReleaseMethods
